import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { handleGetCookie } from "./commonUtil";
import SwalAlert from "../components/common/alert";

const IDLE_LIMIT = 15 * 60 * 1000; // 15 min
const WARNING_TIME = 2 * 60 * 1000; // 2 min before logout

export default function useSessionManager(onLogout) {
    const authData = handleGetCookie('auth');
    const time = (authData.expiresIn - Date.now()) + 60000
    const timer = useRef(null);
    const warningTimer = useRef(null);
    const [showWarning, setShowWarning] = useState(false);

    const resetTimers = () => {
        clearTimeout(timer.current);
        clearTimeout(warningTimer.current);
        setShowWarning(false);
        timer.current = setTimeout(() => {
            onLogout();
        }, time || IDLE_LIMIT);
    };

    useEffect(() => {
        const events = ["mousemove", "keydown", "click", "scroll"];
        events.forEach((event) =>
            window.addEventListener(event, resetTimers)
        );

        resetTimers();

        return () => {
            events.forEach((event) =>
                window.removeEventListener(event, resetTimers)
            );
            clearTimeout(timer.current);
            clearTimeout(warningTimer.current);
        };
    }, []);

    return { showWarning, resetTimers };
}
